import { Daycare } from '@/types/Daycare'
import { OptionsGroup, SelectOption, SelectOptions } from '@/types/Select'
import { Section } from '@/types/Section'
import { OccasionalSlotFormProps } from '../types'
import { OccasionalSlotFormState } from './useOccasionalSlotFormState'
import { useGetOptionChilds } from './useGetOptionChilds'
import { PriorityValue } from '../functions/priorityValues'

type SelectionState = Pick<
    OccasionalSlotFormState,
    'occasionalSlot' | 'selectedSectionId' | 'firstDate' | 'startTime' | 'endTime'
>

export function useOccasionalSlotFormOptions(
    { childs, calendarEvents }: OccasionalSlotFormProps,
    currentDaycare: Daycare,
    { occasionalSlot, selectedSectionId, firstDate, startTime, endTime }: SelectionState
) {
    const childGroupsBaseValue: SelectOptions<number> = useGetOptionChilds({
        childs,
        occasionalSlot,
        selectedSectionId,
        calendarEvents,
        date: firstDate,
        startTime,
        endTime
    })

    const childGroupsForSelect: SelectOptions<PriorityValue> = childGroupsBaseValue.map(
        (group: OptionsGroup<number>) => ({
            ...group,
            options: group.options.map((option) => ({
                ...option,
                value: {
                    type: 'child',
                    id: option.value
                } satisfies PriorityValue
            }))
        })
    )

    const selectOptionsSection: SelectOptions<number> = [
        {
            options:
                currentDaycare.sections?.map((section: Section): SelectOption<number>=> {
                    return {
                        name: section.name.valueOf(),
                        value: section.id
                    }
                }) || []
        }
    ]

    const selectOptionsConfirmChild: SelectOptions<number> = childGroupsBaseValue
    return { selectOptionsSection, childGroupsForSelect, selectOptionsConfirmChild }
}
